import styled from 'styled-components';
import { Flex as DefaultFlex } from 'rebass';

export const Flex = styled(DefaultFlex)`
    width: 100%;
    color: black;
    font-family: "Trebuchet MS", Helvetica, sans-serif;
    max-width: 1080px;
    font-size: 20px;
    text-align: center;
`;